import { useAdminTenantDetails } from '@hakimo-ui/hakimo/data-access';
import { NotFound, QueryResult } from '@hakimo-ui/hakimo/ui-elements';
import { Alert } from '@hakimo-ui/shared/ui-base';
import { useParams } from 'react-router-dom';
import { TenantAdminDetailsView } from './TenantAdminDetailsView';

interface Params extends Record<string, string> {
  tenantId: string;
}

export function TenantAdminDetails() {
  const { tenantId } = useParams<Params>();

  if (!tenantId) {
    return <Alert type="error">Missing tenant ID in URL</Alert>;
  }

  const queryResult = useAdminTenantDetails(tenantId);

  return (
    <QueryResult queryResult={queryResult}>
      {(tenant) => {
        return tenant ? (
          <TenantAdminDetailsView tenant={tenant} />
        ) : (
          <NotFound />
        );
      }}
    </QueryResult>
  );
}

export default TenantAdminDetails;
